import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { getCookie } from '../common/enum';
import axios from '../axios';


const ACTIONS = {
    GET_GROUPS_SUCCESS: 'GET_GROUPS_SUCCESS',
    GET_GROUPS_ERROS: 'GET_GROUPS_ERROS',
    ADD_GROUPS_SUCCESS: 'ADD_GROUPS_SUCCESS',
    ADD_GROUPS_ERROR: 'ADD_GROUPS_ERROR',
    UPDATE_GROUPS_SUCCESS: 'UPDATE_GROUPS_SUCCESS',
    UPDATE_GROUPS_ERROS: 'UPDATE_GROUPS_ERROS',
    REMOVE_GROUP_COMPANY_SUCCESS: 'REMOVE_GROUP_COMPANY_SUCCESS',
    REMOVE_DATA_COMPANY_ERROR: 'REMOVE_DATA_COMPANY_ERROR',
    GET_USERS_LIST_GROUPS_SUCCESS: 'GET_USERS_LIST_GROUPS_SUCCESS',
    GET_USERS_LIST_GROUPS_ERROS: 'GET_USERS_LIST_GROUPS_ERROS',
    ADD_USERS_GROUPS_SUCCESS: 'ADD_USERS_GROUPS_SUCCESS',
    ADD_USERS_GROUPS_ERROR: 'ADD_USERS_GROUPS_ERROR',
    REMOVE_USERS_GROUP_SUCCESS: 'REMOVE_USERS_GROUP_SUCCESS',
    REMOVE_USERS_GROUP_ERROR: 'REMOVE_USERS_GROUP_ERROR',
    UPDATE_USERS_GROUPS_SUCCESS: 'UPDATE_USERS_GROUPS_SUCCESS',
    UPDATE_USERS_GROUPS_ERROR: 'UPDATE_USERS_GROUPS_ERROR',
    GET_USERS_LIST_DELETE_SUCCESS: 'GET_USERS_LIST_DELETE_SUCCESS',
    GET_USERS_LIST_DELETE_ERROR: 'GET_USERS_LIST_DELETE_ERROR'
};

const updateStatus = (type, data) => ({
    type,
    data,
});

// GET
const getGroupsOfCompany = (id, page) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    let url = `${host.serverTest}api/admin/customers/companies/${id}/groups?page=${page}`
    return (dispatch) => {
        callApi(url,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_GROUPS_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_GROUPS_ERROS, err));
            });
    };
}

const getUsersOfGroups = (id, page) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };

    let url = `${host.serverTest}api/admin/customers/companies/${id}/users?sort=created_at&order=asc&page=${page}`
    return (dispatch) => {
        callApi(url,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_USERS_LIST_GROUPS_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_USERS_LIST_GROUPS_ERROS, err));
            });
    };
}

const getUsersInGroupsForDelete = (idComp, idGroup) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    let url = `${host.serverTest}api/admin/customers/companies/${idComp}/groups/${idGroup}/users`
    return (dispatch) => {
        callApi(url,
            config,
            (list) => {
                list.map(val => {
                    val.check = val.group_id ? true : false;
                    return true;
                })
                dispatch(updateStatus(ACTIONS.GET_USERS_LIST_DELETE_SUCCESS, list));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_USERS_LIST_DELETE_ERROR, err));
            });
    };
}

const updateUserOfGroupCompany = (data, idComp, idGroup) => {
    const config = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,

        },
        body: JSON.stringify({
            user_ids: data
        })
    };
    let url = `${host.serverTest}api/admin/customers/companies/${idComp}/groups/${idGroup}/users`
    return (dispatch) => {
        callApi(url,
            config,
            (list) => {
                dispatch(updateStatus(ACTIONS.UPDATE_USERS_GROUPS_SUCCESS, list));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.UPDATE_USERS_GROUPS_ERROR, err));
            });
    };
}

// ADD
const addCompanyGroups = (id, name) => {
    const config = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
        body: JSON.stringify({
            name: name
        })
    };

    let url = `${host.serverTest}api/admin/customers/companies/${id}/groups`;
    return (dispatch) => {
        callApi(url,
            config,
            (dataAdd) => {
                dispatch(updateStatus(ACTIONS.ADD_GROUPS_SUCCESS, dataAdd));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.ADD_GROUPS_ERROR, err));
            });
    };
}

const addUsersGroups = (idComp, params) => {
    return async (dispatch) => {
        try {
            const {data} = await axios.post(`api/admin/customers/companies/${idComp}/users`, {
                name: params.name,
                email: params.email,
                password: params.password,
                group_ids: params.listIdGroup,
                remark: params.remark,
            });
            dispatch(updateStatus(ACTIONS.ADD_USERS_GROUPS_SUCCESS, data));
        }catch (error) {
            dispatch(updateStatus(ACTIONS.ADD_USERS_GROUPS_ERROR, error.response.data));
        }
    }
}

// UPDATE
const editCompanyGroups = (idCp, name, idGroup) => {
    const config = {
        method: 'PUT',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
        body: JSON.stringify({
            name: name
        })
    };

    let url = `${host.serverTest}api/admin/customers/companies/${idCp}/groups/${idGroup}`;
    return (dispatch) => {
        callApi(url,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.UPDATE_GROUPS_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.UPDATE_GROUPS_ERROS, err));
            });
    };
}

const editUserGroups = (idCp, params, idUser) => {
    return async (dispatch) => {
        try {
            const {data} = await axios.put(`api/admin/customers/companies/${idCp}/users/${idUser}`, {
                name: params.name,
                password: params.password || null,
                email: params.emailUser,
                group_ids: params.listIdGroup,
                remark: params.remark,
            });
            dispatch(updateStatus(ACTIONS.UPDATE_USERS_GROUPS_SUCCESS, data));
        }catch (error) {
            dispatch(updateStatus(ACTIONS.UPDATE_USERS_GROUPS_ERROR, error.response.data));
        }
    };
}

// SEARCH
const searchGroups = (text, groupId, page) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    let url = `${host.serverTest}api/admin/customers/companies/${groupId}/groups?sort=created_at&order=asc&page=${page}&keyword=${text}`;
    return (dispatch) => {
        callApi(url,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_GROUPS_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_GROUPS_ERROS, err));
            });
    };
}

const searchUsers = (text, groupId, page) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    let url = `${host.serverTest}api/admin/customers/companies/${groupId}/users?sort=created_at&order=asc&page=${page}&keyword=${text}`;
    return (dispatch) => {
        callApi(url,
            config,
            (data) => {
                dispatch(updateStatus(ACTIONS.GET_USERS_LIST_GROUPS_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.GET_USERS_LIST_GROUPS_ERROS, err));
            });
    };
}

// DELETE
const removeGroup = (idCompany, idGroup) => {
    const config = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    let url = `${host.serverTest}api/admin/customers/companies/${idCompany}/groups/${idGroup}`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                dispatch(updateStatus(ACTIONS.REMOVE_GROUP_COMPANY_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.REMOVE_GROUP_COMPANY_ERROR, err));
            });
    };
}

const removeUserGroup = (idCompany, idUser) => {
    const config = {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    let url = `${host.serverTest}api/admin/customers/companies/${idCompany}/users/${idUser}`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                // console.log({ data });
                dispatch(updateStatus(ACTIONS.REMOVE_USERS_GROUP_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS.REMOVE_USERS_GROUP_ERROR, err));
            });
    };
}


// CONVERT
const convertUsersGroupInModal = (list) => {
    return list.map(items => {
        return {
            name: items.name,
            email: items.id,
            group: items.group,
            remark: items.remark
        }
    });
}

const convertUsersGroupTable = (list) => {
    if (list) {
        let arr = list.map(items => {
            let listGroup = ``;
            items.group.map((v) => {
                listGroup += `${v.name} , `;
                return true;
            })
            listGroup = listGroup.substring(0, listGroup.length - 2);

            return {
                item: [
                    { text: items.name, idUser: items.id },
                    { text: items.email },
                    { text: listGroup, group: items.group, company: items.company ? items.company.name : '' },
                    { text: items.remark !== null ? items.remark : '' },
                    {
                        action: ['設定変更', '削除']
                    }
                ]
            }
        });
        return arr;
    } else {
        return;
    }
}

const convertAdminListUsers = (data) => {
    return data.map(items => {
        return {
            item: [
                { text: items.name, idUserGroup: items.id, name_company: items.company ? items.company.name : '' },
                { text: items.users_count ? items.users_count : '0' },
                {
                    action: [
                        'グループ名変更', '編集', '削除',
                    ]
                }
            ]
        }
    });
};

export {
    ACTIONS, convertAdminListUsers, getGroupsOfCompany,
    addCompanyGroups, editCompanyGroups, searchGroups,
    removeGroup, convertUsersGroupInModal, getUsersOfGroups,
    convertUsersGroupTable, removeUserGroup, addUsersGroups,
    editUserGroups, searchUsers, getUsersInGroupsForDelete,
    updateUserOfGroupCompany
};
